(function () {
  'use strict';

  function initContact(section) {
    if (!section || section.dataset.cleenyContactInit === 'true') return;
    section.dataset.cleenyContactInit = 'true';

    var message = section.querySelector('[data-cleeny-message]');
    var counter = section.querySelector('[data-cleeny-count]');
    var form = section.querySelector('form');
    var submit = section.querySelector('[data-cleeny-submit]');
    var submitText = section.querySelector('[data-cleeny-submit-text]');
    var success = section.querySelector('[data-cleeny-contact-success]');
    var revealItems = section.querySelectorAll('[data-cleeny-reveal]');

    function updateCount() {
      if (!message || !counter) return;
      var max = Number(message.getAttribute('maxlength')) || 600;
      counter.textContent = message.value.length + ' / ' + max;
    }

    if (message) {
      updateCount();
      message.addEventListener('input', updateCount);
    }

    if (form && submit) {
      form.addEventListener('submit', function () {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submitText) submitText.textContent = 'SENDING';
      });
    }

    if (success) {
      window.setTimeout(function () {
        try {
          success.focus({ preventScroll: true });
        } catch (error) {
          success.focus();
        }
      }, 100);
    }

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-cleeny-contact]')) {
      initContact(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-cleeny-contact]').forEach(initContact);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();